import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, FormGroup, Input, Label } from "reactstrap";
import { Btn, H4, H6, P } from "../../../AbstractElements";
import { EmailAddress, OrSignInWith, Password, SignIn } from "../../../Constant";
import FormHeader from "./FormHeader";
import FormPassword from "./FormPassword";
const LoginTab = () => {
  const [email, setEmail] = useState("test@gmail.com");
  const [password, setPassword] = useState("test123");
  const [togglePassword, setTogglePassword] = useState(false);
  const history = useNavigate();

  const loginAuth = async (e) => {
    e.preventDefault();
    if (email !== "" && password !== "") {
      localStorage.setItem("login", JSON.stringify(true));
      history(`${process.env.PUBLIC_URL}/dashboard/default`);
    }
  };

  return (
    <Form className="theme-form">
      <H4>{"Sign In With Simple Login"}</H4>
      <P>{"Enter your email & password to login"}</P>
      <FormGroup>
        <Label className="col-form-label">{EmailAddress}</Label>
        <Input className="form-control" type="email" onChange={(e) => setEmail(e.target.value)} value={email} />
      </FormGroup>
      <FormGroup className="position-relative">
        <Label className="col-form-label">{Password}</Label>
        <div className="position-relative">
          <Input className="form-control" type={togglePassword ? "text" : "password"} autoComplete="" onChange={(e) => setPassword(e.target.value)} value={password} />
          <div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}>
            <span className={togglePassword ? "" : "show"}></span>
          </div>
        </div>
      </FormGroup>
      <FormPassword />
      <div>
        <Btn attrBtn={{ color: "primary", className: "d-block w-100 mt-2", onClick: (e) => loginAuth(e) }}>{SignIn}</Btn>
      </div>
      <div className="login-social-title">
        <H6>{OrSignInWith}</H6>
      </div>
      <FormHeader />
    </Form>
  );
};

export default LoginTab;
